import { useTranslation, Trans } from 'react-i18next'
import Link from '@web-ui-kit/link'
import { useHistory } from 'react-router-dom'
import Text from '@web-ui-kit/text'
import Alert from '@web-ui-kit/alert'
import * as Sc from './ChatIANotification.style'
import { ROUTES } from 'routes/paths'
import useCheckCanary from 'hooks/useCheckCanary'
const ChatIANotification = () => {
  const { t } = useTranslation()
  const { push } = useHistory()
  const showNewAlertCenter = useCheckCanary(
    window?.rebranding?.canaryUsers,
    window?.rebranding?.enableAlerteCenter
  )

  const renderChatIAAlert = () => (
    <Sc.Container>
      <Text variant={'small'}>
        <Trans i18nKey='¿Aún no has probado el asistente de inteligencia artificial ChatIA? Accede a tus libros y utiliza cualquiera de los helpers disponibles para generar recursos educativos en pocos minutos'>
          <strong>¿Aún no has probado el ChatIA?</strong> Accede a tus libros y
          utiliza cualquiera de los helpers disponibles para generar recursos
          educativos en pocos minutos.
        </Trans>
      </Text>
      <Link
        dataTestId='go-books-link'
        id='books-link'
        onClick={() => push(ROUTES.BOOKS)}
        role='link'
        size='small'
        variant='secondary'
      >
        {t('Ir a mis libros')}
      </Link>
    </Sc.Container>
  )

  return showNewAlertCenter ? (
    renderChatIAAlert()
  ) : (
    <Alert
      dataTestId='chatia-alert'
      description={renderChatIAAlert()}
      id='alert-chatIA-id'
      variant='info'
    />
  )
}

export default ChatIANotification
